export default __webpack_public_path__ + "static/onboarding.light-6188d11cf79fddf47e6ec12a9bb228bd4d3fca1f00d335e3eb1435a6e211f131.png";